import actions from './actions';

const { GET_LOAD, GET_SUCCESS, GET_ERROR } = actions;

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const diagnosticReducer = (state = initialState, action) => {
  const { type, diagnostic, err } = action;

  switch (type) {
    case GET_LOAD:
      return { ...state, data: [], loading: true };

    case GET_SUCCESS:
      return { ...state, data: diagnostic, error: false, loading: false };

    case GET_ERROR:
      return { ...state, error: err, loading: false };

    default:
      return state;
  }
};

export { diagnosticReducer };
